import Alpine from 'alpinejs'
import masonry from 'alpinejs-masonry'
import collapse from '@alpinejs/collapse'
import intersect from '@alpinejs/intersect'
 
export const initAlpine = () => {
  
  window.Alpine = Alpine
	
	Alpine.plugin(masonry)
	Alpine.plugin(collapse)
	Alpine.plugin(intersect)
  Alpine.start()

}